import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React from 'react';
import styled from 'styled-components';

import ButtonWithSpinner from '../ButtonWithSpinner';
import { ButtonWithSpinnerType } from '../ButtonWithSpinner/types';

const ActionButtonStyled = styled(ButtonWithSpinner)`
  min-width: 80px;
  &:hover,
  &:focus {
    opacity: 0.8;
  }
`;

const CancelButtonStyled = styled(Button)`
  background-color: #e0e0e0;
  border: none;
  &:hover,
  &:focus {
    opacity: 0.8;
    background-color: #e0e0e0;
    color: initial;
  }
  margin: 0;
`;

export const ConfirmButton: React.FC<ButtonWithSpinnerType> = ({ className, ...props }) => (
  <ActionButtonStyled width='auto' {...props} className={`${className || ''} confirm-button`} />
);

export const CancelButton: React.FC<ButtonProps> = ({ className, ...props }) => (
  <CancelButtonStyled type='default' {...props} className={`${className || ''} cancel-button`} />
);

export const WarningButton: React.FC<ButtonWithSpinnerType> = (props) => (
  <ActionButtonStyled buttonType='text' color='red' className='gx-m-0' spinnerColor='lightgrey' {...props} />
);
